/**
 * atomberg-support-track-complaint.js
 *
 * Track Complaint tab — looks up complaint status by ticket number or
 * mobile number (at least one required, validated manually since neither
 * field is individually `required`). Calls
 * GET {api_base_url}/api/support/track?mobile_number=&case_number=
 * and renders each case with its status, plus any child cases (grouped
 * installation line-item tickets) indented beneath their parent.
 */
(function () {
  'use strict';

  var w = /** @type {any} */ (window);
  if (w._atombergSupportTrackInit) return;
  w._atombergSupportTrackInit = true;

  /** @returns {string} */
  function getApiBaseUrl() {
    var root = document.querySelector('[data-support-api-base-url]');
    return (root && root.getAttribute('data-support-api-base-url')) || '';
  }

  /**
   * @param {string} apiBaseUrl
   * @param {string} mobile
   * @param {string} caseNumber
   * @returns {Promise<{status: boolean, message: string, cases: Array<{case_number: string, case_status: string, child_cases?: Array<{case_number: string, case_status: string}>}>}>}
   */
  function trackComplaint(apiBaseUrl, mobile, caseNumber) {
    var params = new URLSearchParams();
    if (mobile) params.set('mobile_number', mobile);
    if (caseNumber) params.set('case_number', caseNumber);
    return fetch(apiBaseUrl + '/api/support/track?' + params.toString(), {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return {
          status: false,
          message: 'Could not check complaint status. Please try again.',
          cases: [],
        };
      });
  }

  /**
   * @param {{case_number: string, case_status: string, child_cases?: Array<{case_number: string, case_status: string}>}} c
   * @returns {string}
   */
  function renderCase(c) {
    return (
      '<li class="atomberg-support-track__case">' +
      '<div class="atomberg-support-track__case-row">' +
      '<span>Case No. ' +
      c.case_number +
      '</span>' +
      '<span class="atomberg-support-track__status">Status: ' +
      c.case_status +
      '</span>' +
      '</div>' +
      '</li>'
    );
  }

  /** @param {HTMLElement} root */
  function init(root) {
    var mobileInputEl = /** @type {HTMLInputElement|null} */ (
      root.querySelector('[data-support-track-mobile]')
    );
    var caseInputEl = /** @type {HTMLInputElement|null} */ (
      root.querySelector('[data-support-track-case]')
    );
    var submitBtnEl = /** @type {HTMLButtonElement|null} */ (
      root.querySelector('[data-support-track-submit]')
    );
    var errorEl = /** @type {HTMLElement|null} */ (
      root.querySelector('[data-support-track-error]')
    );
    var resultsElEl = /** @type {HTMLElement|null} */ (
      root.querySelector('[data-support-track-results]')
    );
    var noRecordEl = /** @type {HTMLElement|null} */ (
      root.querySelector('[data-support-track-empty]')
    );
    if (!mobileInputEl || !caseInputEl || !submitBtnEl || !resultsElEl) return;
    var mobileInput = mobileInputEl;
    var caseInput = caseInputEl;
    var submitBtn = submitBtnEl;
    var resultsEl = resultsElEl;

    submitBtn.addEventListener('click', function () {
      var mobile = mobileInput.value.trim();
      var caseNumber = caseInput.value.trim();
      if (errorEl) errorEl.hidden = true;
      if (noRecordEl) noRecordEl.hidden = true;
      resultsEl.innerHTML = '';

      if (!mobile && !caseNumber) {
        if (errorEl) {
          errorEl.textContent = 'You have to enter either Ticket Number or Mobile Number Above!';
          errorEl.hidden = false;
        }
        return;
      }
      if (mobile && !/^[6-9]\d{9}$/.test(mobile)) {
        if (errorEl) {
          errorEl.textContent = 'Invalid mobile number';
          errorEl.hidden = false;
        }
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Fetching Details. Please wait...';

      trackComplaint(getApiBaseUrl(), mobile, caseNumber).then(function (res) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Track Now';

        if (!res.status) {
          if (errorEl) {
            errorEl.textContent = res.message || 'Could not check complaint status.';
            errorEl.hidden = false;
          }
          return;
        }
        var cases = res.cases || [];
        if (!cases.length) {
          if (noRecordEl) noRecordEl.hidden = false;
          return;
        }
        resultsEl.innerHTML = cases.map(renderCase).join('');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-support-track-complaint]').forEach(function (el) {
      init(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
